import React from 'react';

type VerifyEmailIllustrationProps = {
    isMobile?: boolean;
};

export const VerifyEmailIllustration = ({ isMobile = false }: VerifyEmailIllustrationProps) => {
    const imageSize = isMobile ? '104' : '164';

    return (
        <svg
            width={imageSize}
            height={imageSize}
            viewBox="0 0 164 164"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="164" height="164" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d={
                    'M138.77 88.9303C144.426 85.6584 148.231 79.543 148.231 72.5388C148.231' +
                    ' 62.0879 139.759 53.6157 129.308 53.6157C121.069 53.6157 114.06 58.8814' +
                    ' 111.462 66.2311H45.5334C41.2882 66.2311 37.8467 69.0083 37.8467 72.4341V129' +
                    '.413C37.8467 132.839 41.2882 135.616 45.5334 135.616H131.083C135.328 135.616' +
                    ' 138.77 132.839 138.77 129.413V88.9303Z'
                }
                fill="#DEE6FD"
            />
            <path
                d={
                    'M120.044 123H34.4944C30.2491 123 26.8076 120.223 26.8076 116.797V59.8183C26.8076' +
                    ' 56.3924 30.2491 53.6152 34.4944 53.6152H120.044C124.289 53.6152' +
                    ' 127.731 56.3924 127.731 59.8183V116.797C127.731 120.223 124.289' +
                    ' 123 120.044 123Z'
                }
                fill="white"
            />
            <path
                d={
                    'M127.731 59.8183L81.0096 94.226C78.785 95.8642 75.7533 95.8642 73.5287' +
                    ' 94.226L26.8076 59.8183C26.8076 56.3924 30.2491 53.6152 ' +
                    '34.4944 53.6152H120.044C124.289 53.6152 127.731 56.3924 127.731 59.8183Z'
                }
                fill="white"
                stroke="#DEE6FD"
                strokeMiterlimit="10"
            />
            <path
                d={
                    'M120.044 123H34.4944C30.2491 123 26.8076 120.223 26.8076 116.797V59.8183C26.8076' +
                    ' 56.3924 30.2491 53.6152 34.4944 53.6152H120.044C124.289 53.6152 ' +
                    '127.731 56.3924 127.731 59.8183V116.797C127.731 120.223 124.289 ' +
                    '123 120.044 123Z'
                }
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <rect
                x="99.8462"
                y="41.5"
                width="36.8462"
                height="36.8462"
                rx="18.4231"
                fill="#FFBE5E"
            />
            <rect
                x="99.8462"
                y="41.5"
                width="36.8462"
                height="36.8462"
                rx="18.4231"
                stroke="#333333"
            />
            <path
                d="M108.808 59.9229L115.115 66.2306L127.731 53.6152"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};
